import React, { FC } from 'react';
import { PageContainer } from '@/ui/components';
import { TransportDataGrid } from './components/TransportMovementDataGrid';

export const TransportMovement: FC = () => (
  <div style={{ height: '100%', overflowY: 'auto', containerType: 'size' }}>
    <PageContainer>
      <TransportDataGrid />
    </PageContainer>
  </div>
);
